import axios from 'axios'

export default async function getCountries() {
  const apiUrl = process.env.REACT_APP_API_URL
  const response = await axios.post<any>(`${apiUrl}/Country/GetAllCountry`, {
    paging: {
      currentPageNumber: 1,
      pageSize: 10000,
    },
  })
  return response.data.response.data
}
